import { React, useEffect, useRef, useState , PureComponent } from 'react'
import { motion, AnimatePresence, delay } from 'framer-motion'
import 'bootstrap/dist/css/bootstrap.min.css';
import visalogo from '../../Images/visalogo.png'
import { Col, Row } from 'react-bootstrap';
import { faHandHoldingDollar, faHourglassHalf, faMoneyBills, faMoneyCheckDollar,faCircleInfo } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Card, CardBody } from '@nextui-org/react';
import axios from 'axios';
import BackEndUrl from '../../backURL';
import loading from "../../Images/three-dots.svg"
import { Loader } from '../../components/loaders/Loader';
import { Chart } from 'primereact/chart';
import { Toast } from 'primereact/toast';
import PolicyDetails from './PolicyDetails';
import UseCustomFormik from '../formik';
import UserDetailAlt from "../CustomerServicing"

const backend =BackEndUrl.domain;
export const Dashboard = ({data,policy_number}) => {

    const [req_count, SetReqCount] = useState(null)
    
    const selectedData = data && data.find(value => value.policy_number == policy_number); //selected the data related to the specific policy of the user
    const [selected_service, setSelectedService] = useState([0])
    const formik = UseCustomFormik(selected_service, data, policy_number); //passing the data for validation
    const [pendingRequest,setPendingRequest] = useState(null)
    useEffect(()=>{
    async function GetPendingRequest(){
     
        const selectedData = data && data.find(value => value.policy_number == policy_number);
        const response = await axios.post(backend + "/check-pending-reqs", {
            policy_number: policy_number,
            user_id: selectedData.user_id,
        }, {
            headers: {
                Authorization: sessionStorage.getItem('token'),
            }
        })
        setPendingRequest( response.data[0] && response.data[0].req_count)

     }
      if(!pendingRequest){
        GetPendingRequest()
      }


    },[])


    const options = {
      maintainAspectRatio: false,
      aspectRatio: 0.8,
      plugins: {
          legend: {
              labels: {
                  fontColor: "black"
              }
          }
      },
      scales: {
          x: {
              ticks: {
                  color: "black",
                  font: {
                      weight: 500
                  }
              },
              grid: {
                  display: false,
                  drawBorder: false
              }
          },
          y: {
              ticks: {
                  color:"black"
              },
              grid: {
                  color: "black",
                  drawBorder: false
              }
          }
      }
  };
  const Chartdata = {
    labels: ['January', 'February', 'March', 'April', 'May', 'June', 'July'],
    datasets: [
        {
            label: 'My First dataset',
            backgroundColor: "blue",
            borderColor:"blue",
            data: [65, 59, 80, 81, 56, 55, 40]
        },
       
    ]
};

const toast = useRef(null);

  return (

    

    <motion.div
    initial={{
        y: "30%",
        opacity: 0
    }}
    animate={{
        y: "0%",
        opacity: 1,
        transition: { duration: 0.3 }
    }}
>



    <Row  className='d-flex justify-content-center'>
        <Col lg={12} xs={12} md={6} sm={12} className='d-flex justify-content-center'>
            
            <Row style={{width:'100%'}}>

            {
            selected_service == "0" ?
            <Row style={{width:'100%'}}>

                <Col lg={3} xs={12} sm={12} md={6}>

                <motion.div
                        initial={{
                            y: "50%",
                            opacity: 0
                        }}
                        animate={{
                            y: "0%",
                            opacity: 1,
                            transition: { duration: 0.3, delay: (0.1 * 1) }
                        }}
                        whileHover={{
                            scale: 0.9,
                            transition: { duration: 0.1 },
                           
                        }}

                        onClick={() => { setSelectedService(1); }}
                    >

                        <Card className="py-2 my-4" style={{ width: "100%", height: "30vh" , backgroundColor:"#ff8a57ff" , cursor: "pointer"}}>

                            <CardBody className="overflow-visible py-2 d-flex align-items-center justify-content-center" style={{ textAlign: "center" }}>
                                <FontAwesomeIcon icon={faCircleInfo} className='my-3' style={{ height: "3vh" }} />
                                <p style={{ fontSize: "16px", width: "75%" , fontWeight:"bold"}} >My Policy Details</p>                    
                                <p className='' style={{fontSize:"15px",color:"#FFFFFF",visibility: "visible"}}>Covers Details  Payment Histories</p>
                                
                            </CardBody>
                        </Card>

                        </motion.div>
                </Col>
            
            
            {/* <Col lg={3} xs={12} sm={12} md={6}>
                <Card className="py-2 my-4" style={{ width: "100%", height: "30vh" , backgroundColor:"#FFDD95" , cursor: "pointer"}}>
                      <CardBody className="overflow-visible py-2 d-flex align-items-center justify-content-center" style={{ textAlign: "center" }}>
                      <FontAwesomeIcon icon={faHourglassHalf}  className='my-3' style={{ height: "3vh" }} />
                      <p style={{ fontSize: "16px", width: "100%", fontWeight:"bold" }} >Pending Requets</p>
                      {pendingRequest!=null?<p className='' style={{fontWeight:"bold",fontSize:"20px",color:"#FB4C01"}}>{(pendingRequest ==0) ? <p className='' style={{fontSize:"12px",color:"#5A5A5A",visibility: "visible"}}>No requests placed</p> : pendingRequest} </p>:
                      <Loader style={{height:"35px",width:"35px",margin:"2px"}}/>
                    
                      }

                      </CardBody>
                    </Card>
                </Col> */}
                
                <Col lg={3} xs={12} sm={12} md={6}>
                <Card  className="py-2 my-4" style={{ width: "100%", height: "30vh" , backgroundColor:"#FFFFFF" , cursor: "pointer"}} >
                      <CardBody className="overflow-visible py-2 d-flex align-items-center justify-content-center" style={{ textAlign: "center" }} onClick={() => window.open("https://ieg.sicl.lk/pay-life-insurance", "_blank")}>
                      <img src={visalogo} alt="Pay Online" className='my-3' style={{ width: "80%", height: "40%" }} />
                      <p style={{ fontSize: "16px", width: "100%", fontWeight:"bold" }} >Online Payment</p> 

                      {/* https://www.payeasy.lk/SPEClientWeb/ActionController?sblparam=Z6spFdlqDbLImtIUQTsvPyv%2Fk8JOyEaNGLKJO5RKEgNBcXLIYTI8%2FLfutSZrsk6aqfYI8Ac9d8UX%0D%0AY4g7Zu8Eh%2FvtchrdGJI9FDJi2yNzz0pI%2BVREM9wsy7g7ANciNmdwkDOSRFnkqy5hXkGLQPVnotMWz8Y5%0D%0Ak3PaoX44gyqRHnjE                   */}

                      </CardBody>
                    </Card>
                </Col>
                </Row> 

                            : null
            }
            {
                        selected_service == "1" ?
                            <PolicyDetails formik={formik} setSelectedService={setSelectedService} selectedData={selectedData} req_count={req_count} UserDetailAlt={UserDetailAlt} policy_number={policy_number} />

                            : null
            }

            

                
            </Row>           
            
            
        </Col>
       

    </Row>



</motion.div>


  )


  
}
export default Dashboard;
